// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-searcher";
import "./../../factories/bao-dialog";
import "./../../factories/tree-node";
import "./../../bindings/bao-tree";
import baoDialog from "./../../factories/bao-dialog";
import TreeNodeViewModel from "./../../factories/tree-node";
function ExpandedSearchTicket(parent) {
    var self = this;
    var htmlUrl = "ExpandedSearchSynoset/ExpandedReminderTicket";
    var baoDialog = window.baorequire("Factories/baoDialog");
    var TreeNodeViewModel = window.baorequire("Factories/TreeNode");
    self.LoadHtml = function () {
        return Bao.get(htmlUrl, function (result) {
            Bao.Templates[htmlUrl] = result;
            parent.ExpandedSearchTemplateName(htmlUrl);
            parent.ExpandedSearchVisible(true);
        });
    };
    self.InitFilter = function () {
        return Bao.post("ExpandedSearchSynoset/ExpandedReminderTicketInit", function (result) {
            if (result != null && result != "") {
                self.TicketStatusId(result.TicketStatusId);
                self.Status(result.TicketStatus);
            }
        });
    };
    self.Status = ko.observable();
    self.TicketStatusId = ko.observable();
    self.TicketStatusId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.OwnerServiceProviderId = ko.observable("");
    self.OwnerServiceProviderName = ko.observable("");
    self.OwnerServiceProviderId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SearcherOwnerServiceProvider = {
        ObjectId: this.OwnerServiceProviderId,
        ObjectValue: "ServiceProvider",
        SearchType: "ServiceProvider",
        AutoSearch: true,
        AutoComplete: true
    };
    self.FromDate = ko.observable("");
    self.FromDate.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.FromDateTimePicker = {
        mode: "date"
    };
    self.FromDateTimeBox = {
        value: self.FromDate,
        mode: "date",
        culture: Bao.Session.Language.Symbol()
    };
    self.ToDate = ko.observable("");
    self.ToDate.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.ToDateTimePicker = {
        mode: "date"
    };
    self.ToDateTimeBox = {
        value: self.ToDate,
        mode: "date",
        culture: Bao.Session.Language.Symbol()
    };
    self.ConfigurationItemId = ko.observable("");
    self.FullName = ko.observable("");
    self.ConfigurationItemId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SearcherPerson = {
        ObjectId: this.ConfigurationItemId,
        ObjectValue: "FullName",
        SearchType: "Person",
        AutoSearch: true,
        AutoComplete: true
    };
    self.TicketTypeName = ko.observable();
    self.TicketTypeId = ko.observable();
    self.TicketTypeId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SearcherTicketType = {
        ObjectId: this.TicketTypeId,
        ObjectValue: "Type",
        SearchType: "TicketType",
        AutoSearch: true,
        AutoComplete: true,
        MultiSelect: true,
        CustomFilter: {
            TicketTypeCategoryId: "12374dc1-884e-4fea-a3bf-0b834b695fdf"
        }
    };
    self.ServiceId = ko.observable("");
    self.ServiceId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.ServiceName = ko.observable();
    self.OpenTreeDialog = function (type, tabtype) {
        var _this = this;
        var ticketTypeCategoryIdFilter = "12374dc1-884e-4fea-a3bf-0b834b695fdf";
        Bao.post("Ticket/GetTreeDialogDataSource", JSON.stringify({
            type: type,
            ticketTypeCategoryId: ticketTypeCategoryIdFilter
        }), function (value) {
            var dialog = new baoDialog(Bao.Session.ApplicationName);
            var dialogViewModel : any = {};
            dialogViewModel.NodeToggled = function (node) {
                var _this = this;
                if (node.Loaded() == false) {
                    var parentId = node.Id();
                    Bao.post("Ticket/GetTreeDialogDataSourceByParent", JSON.stringify({
                        type: type,
                        parentId: parentId,
                        ticketTypeCategoryId: ticketTypeCategoryIdFilter
                    }), function (value) {
                        for (var i = 0; i < value.nodes.length; i++) {
                            node.Nodes.push(new TreeNodeViewModel(value.nodes[i]));
                        }
                        node.Expanded(true);
                        node.Loaded(true);
                        dialog.SetPosition();
                    });
                }
                else {
                    dialog.SetPosition();
                }
            };
            var dataSource = [];
            for (var i = 0; i < value.nodes.length; i++) {
                dataSource.push(new TreeNodeViewModel(value.nodes[i]));
            }
            dialogViewModel.Nodes = ko.observableArray(dataSource);
            dialogViewModel.SelectedService = ko.observable();
            var selectedServiceSubscription = dialogViewModel.SelectedService.subscribe(function () {
                dialogViewModel.okClick();
            });
            dialogViewModel.okClick = function () {
                var selectedNode;
                selectedNode = dialogViewModel.SelectedService();
                if (selectedNode != null) {
                    if (selectedNode.IsAllowed()) {
                        return Bao.post("Ticket/GetTicketServiceStructure", JSON.stringify({
                            selectedTicketServiceId: selectedNode.Id()
                        }), function (result) {
                            self.InitializeDataBindingTicketServiceStructure(result.TicketServiceStructureId);
                            self.ServiceId(result.TicketServiceStructureId);
                            dialog.Close();
                            selectedServiceSubscription.dispose();
                            selectedServiceSubscription = null;
                            dialogViewModel.SelectedService(null);
                        });
                    }
                }
                new baoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("TicketServiceInvalidSelection"), "info");
                return null;
            };
            dialog.Width("500px");
            dialog.ViewModel(dialogViewModel);
            dialog.Template(value.Message);
            dialog.Open();
            dialog.SetPosition();
        });
    };
    self.InitializeDataBindingTicketServiceStructure = function (id) {
        return Bao.post("Ticket/GetCompleteTicketServiceStructure", JSON.stringify({
            id: id
        }), function (value) {
            self.ServiceName(value);
        });
        parent.CustomFilter(self.GetCustomFilter());
    };
    self.DeleteService = function () {
        self.ServiceName(null);
        self.ServiceId(null);
    };
    self.GetCustomFilter = function () {
        if (self.TicketStatusId() == null && self.OwnerServiceProviderId() == null && self.ToDate() == null && self.FromDate() == null && self.PersonId == null && self.ServiceId == null) {
            return null;
        }
        else {
            return {
                TicketStatusId: self.TicketStatusId(),
                TicketTypeId: self.TicketTypeId(),
                OwnerServiceProviderId: self.OwnerServiceProviderId(),
                FromDate: self.FromDate(),
                ToDate: self.ToDate(),
                PersonId: self.ConfigurationItemId(),
                ServiceId: self.ServiceId()
            };
        }
    };
    self.init = function () {
        return self.LoadHtml().then(function () {
            self.InitFilter();
        });
    };
}
export default ExpandedSearchTicket;